'use strict';

var React = require('react');
var l10n = require('@iziwork/l10n');
var component = require('../CustomFormatInput/component.js');
require('../../../theme/breakpoints.js');
require('imask');
var useRefAndForward = require('../../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var useValidityState = require('../../../hooks/useValidityState.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const defaultAcceptChar = (char) => /[ 0-9+\-()]/.test(char);
const states = ['valueMissing', 'tooShort', 'tooLong', 'customError'];
const PhoneInput = React.forwardRef(({ countryCode, displayFormat = l10n.PhoneNumberType.NATIONAL, parseFormat = l10n.PhoneNumberType.E164, acceptChar = defaultAcceptChar, onValidityChange, value, ...props }, ref) => {
    const inputRef = useRefAndForward.useRefAndForward(null, ref);
    useValidityState.useElementValidityState(states, { value, elementRef: inputRef, onValidityChange, required: props.required });
    const format = React.useCallback((parsedValue) => l10n.formatPhoneNumber({ phoneNumber: parsedValue ?? '', countryCode, format: displayFormat }).phoneNumber, [countryCode, displayFormat]);
    const parse = React.useCallback((phoneNumber) => l10n.formatPhoneNumber({ phoneNumber, countryCode, format: parseFormat }).phoneNumber, [countryCode, parseFormat]);
    return (React__default.default.createElement(component.CustomFormatInput, { ...props, ref: inputRef, value: value, acceptChar: acceptChar, parse: parse, format: format }));
});

exports.PhoneInput = PhoneInput;
exports.states = states;
//# sourceMappingURL=component.js.map
